function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { Icon } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export let SemanticIconName = /*#__PURE__*/function (SemanticIconName) {
  SemanticIconName["Yes"] = "CheckMark";
  SemanticIconName["No"] = "Cancel";
  SemanticIconName["GoTo"] = "NavigateForward";
  SemanticIconName["GoBack"] = "NavigateBack";
  SemanticIconName["FromUntil"] = "ChevronRight";
  SemanticIconName["Alert"] = "AlertSolid";
  SemanticIconName["Expand"] = "DoubleChevronDown8";
  SemanticIconName["Collapse"] = "DoubleChevronUp8";
  SemanticIconName["RedFlag"] = "Flag";
  SemanticIconName["Territory"] = "Globe2";
  SemanticIconName["Date"] = "Calendar";
  SemanticIconName["Time"] = "Timer";
  SemanticIconName["Unknown"] = "Unknown";
  SemanticIconName["External"] = "NavigateExternalInline";
  SemanticIconName["Attachment"] = "Attach";
  SemanticIconName["Info"] = "Info";
  SemanticIconName["Star"] = "FavoriteStar";
  SemanticIconName["CheckAll"] = "ReceiptCheck";
  SemanticIconName["UncheckAll"] = "ReceiptUndelivered";
  SemanticIconName["ErrorX"] = "StatusCircleErrorX";
  SemanticIconName["ErrorCircleX"] = "ErrorBadge";
  return SemanticIconName;
}({});
export let SemanticIconSize = /*#__PURE__*/function (SemanticIconSize) {
  SemanticIconSize[SemanticIconSize["ExtraSmall"] = 8] = "ExtraSmall";
  SemanticIconSize[SemanticIconSize["Small"] = 14] = "Small";
  SemanticIconSize[SemanticIconSize["Medium"] = 18] = "Medium";
  SemanticIconSize[SemanticIconSize["Large"] = 32] = "Large";
  return SemanticIconSize;
}({});
export const SemanticIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    semanticName,
    size,
    dataId,
    styles
  } = _ref;
  const rootStyles = typeof styles === 'object' ? styles === null || styles === void 0 ? void 0 : styles.root : undefined;
  return /*#__PURE__*/_jsx(Icon, {
    "data-id": dataId,
    iconName: semanticName,
    styles: {
      root: _objectSpread(_objectSpread({}, rootStyles), {}, {
        fontSize: size
      })
    }
  });
});
SemanticIcon.displayName = 'SemanticIcon';